import en from './locales/en/main';
import nl from './locales/nl/main';
import es from './locales/es/main';

export default {
  en: en,
  nl: nl,
  es: es,
};
